module.exports = __webpack_public_path__ + "media/images/lb/752-1b8e151cf596645b100aea646740f928.svg";